import addToCartTracking from 'global/addToCart/addToCartTracking';
import AddToCartFormControl from 'global/addToCart/AddToCartFormControl';

const addToCart = () => {
	addToCartTracking();

	loadAddToCartInstances();

	window.od.events.subscribe('richRelevance_Loaded', ({ element }) =>
		loadAddToCartInstances(element),
	);

	window.od.events.subscribe('switchAndSave_Switched', ({ element }) =>
		loadAddToCartInstances(element),
	);

	window.od.events.subscribe(
		'algolia_hybrisEnrichment_renderedProductTiles',
		({ element }) => loadAddToCartInstances(element),
	);
};

function loadAddToCartInstances(parentNode = document) {
	const addToCartForms = parentNode.querySelectorAll('[id*="addToCartForm_"]');
	Array.from(addToCartForms).forEach(form => new AddToCartFormControl(form));
}

export default addToCart;
